import {ImplPincodeService} from '../app/services/pincode/impl-pincode.service';

export const trgEnvironment = {
  environment: 'trg',
  production: false,
  translateURL: 'https://www.uat.telenet.be/telenet/data/locale/i18n.html/eos-tv-shop/',
  baseUrl: 'https://www.uat.telenet.be',
  translateSuffix: '/labels',
  pincodeServiceType : ImplPincodeService,
  baseApiUrl: 'https://api.trg.telenet.be',
  sofyApiUrl: 'https://uat.sofy-stage.awscloud.external.telenet.be/sofy/public/'
};
